  <div class="page-title-section row m-0 pt-5 pb-4 flex-column">
    <div class="main-title main-theme-color d-flex text-uppercase justify-content-center text-center text-uppercase">
      {{!activityService.isDining ? (activityService.isNonDining ? activityService.selectedNonDining.RestaurantName : selectedActivity?.Name) : activityService.selectedDining.RestaurantName}}
    </div>
    <div class="main-title main-theme-color d-flex justify-content-center text-center text-uppercase">{{'guestDetails' |
      translate}}</div>
    <div class="sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">
      {{'reservationSubTitle' | translate}}
    </div>
  </div>
  <!-- AddOn Selection Container -->


  <div class="container activity-data mt-3">
    <!-- <mat-expansion-panel hideToggle class="mb-3 activity-accordian-panel" *ngIf="selectedActivity">

    <mat-expansion-panel-header class="activity-panel-header">
      <div class="w-100 order-summary-short-detail-section p-3 mx-2 d-flex flex-row justify-content-between" [ngStyle]="{'background-color': this.selectedActivity.isAvailable ? 'rgba(255,0,0,0.1)' : ''}">
        <div
          class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
          <mat-icon>card_travel</mat-icon>
          <div class="px-2 order-details-activity-name text-wrap text-center">{{this.selectedActivity.LessonName}}</div>
        </div>
        <div class="order-summary-spacer mx-2"></div>
        <div
          class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
          <mat-icon>person</mat-icon>
          <div class="px-2 text-center">{{this.activityService.selectedSize}}</div>
        </div>
        <div class="order-summary-spacer mx-2"></div>
        <div
          class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
          <mat-icon>calendar_today</mat-icon>
          <div class="px-2 text-center">
            <ng-container>{{this.activityService.selectedSlot.Start | date: 'dd MMM
              yyyy'}}</ng-container>
          </div>
        </div>
        <div class="order-summary-spacer mx-2"></div>
        <div
          class="activity-selected-time activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
          <mat-icon>access_time</mat-icon>
          <div class="px-2 d-flex align-items-center justify-content-center">
            <span class="text-center">
              <ng-container>{{this.activityService.selectedSlot.Start | date: 'hh:mm
                a'}}</ng-container>
            </span>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>
    </mat-expansion-panel> -->
    <div class="row activity-lite">
      <!-- <div class="col-lg-2 col-md-2 col-xl-2"></div> -->
      <div class="col-lg-12 col-md-12 col-xl-12 col-xs-12 addon place-content-center"  >
      <div class="row">
        <mat-card class="col-lg-6 col-md-12 col-xl-6 col-sm-12 col-xs-12 float-left" [ngStyle]="{'max-height': !expand ? '70px' : '600px'}"  *ngIf="(mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0) && allEligibleAddOns?.length" 
          [class.collapseMode]="!expand" style="
       transition: 0.5s;
        padding: 0;
        border: 1px solid #ededed;
        margin-bottom: 18px;
        padding-bottom: 15px;
        position: relative;
        overflow: auto;
        ">
    <div class="addon__header">
      <span>{{'addons' | translate}}
        <span *ngIf="mandatoryCategoryAddons?.length" style="font-weight: bold;color: red;font-size: 20px;"> *</span>
      </span>
    <span *ngIf="screenWidth < 992" class="arrow-view icon-Right-Arrow" (click)="expandAddOn()"></span>
    <div class="addon__mandatory-info" *ngIf="mandatoryCategoryAddons?.length && (screenWidth >= 992 || expand)">
      <div *ngFor="let name of mandatoryCategoryAddons">
        {{ 'minCategoryAddonMessage' | translate: {name: name} }}
      </div>
    </div>
  </div>
    <div class="addon__panel-view">
      <div class="addon__panel-body">
    <div *ngFor="let item of allEligibleAddOns" class="addon__addon-section"
      [ngStyle]="{'border-bottom-color':item | getCategoryData :  restaurantData.PreferencesCategories  :'Color' }">
      <div *ngIf="item.IsVisible" class="addon__card-details">
        <div class="addon__card-view">
          <div class="addon__addon-details">
            <div class="addon__name">
              <span class="addon_name_formatted" [title]="item.AddonName">
                {{item.AddonName}}</span>
              <span *ngIf="item.IsMandatory" style="font-weight: bold;color: red;font-size: 20px;"> *</span>
            </div>
            <span class="seat-labels"
              [ngStyle]="{'color':item | getCategoryData :  restaurantData.PreferencesCategories  :'Color' }">
              {{item | getCategoryData : restaurantData.PreferencesCategories  :'Text'}}</span>
          </div>
          <div class="addon__addon-price">
            <div style="text-align:right">{{restaurantData.OperationCurrency}} {{item.Price | currencyDecimalFormatter}}
            </div>
            <div *ngIf="item.PricingCategory == PricingCategory.ByDuration">
              <span class="seat-body-text" *ngIf="item.PricingType == PricingType.ByHour">
                For {{ item.AddOnDetails[0].Duration }} {{'hours' | translate}}</span>
              <span class="seat-body-text" *ngIf="item.PricingType == PricingType.ByMinutes">
                For {{ item.AddOnDetails[0].Duration }} {{'minutes' | translate}}</span>
            </div>
            <div class="seat-body-text" *ngIf="item.PricingCategory == PricingCategory.BySession">{{'perSession' |
              translate}}</div>
          </div>
        </div>
        <div class="addon__card-quantity seat-header-four">
          <div class="addon__availablility">
            <label for="" class="addon__available-text">{{"available" | translate}}</label>
            <label *ngIf="!item.IsUnlimited" class="seat-grid-content" for="">
              <span
                [ngClass]="{'addon__available': item.AvailableQuantity, 'addon__soldout' : !item.AvailableQuantity }">{{item.AvailableQuantity}}</span>
              of {{item.OverAllQuantity}}</label>
            <label class="addon__unlimited" *ngIf="item.IsUnlimited">
              {{'Unlimited' | translate}}
            </label>
          </div>

          <div class="addon__quantity-selection">
            <div class="addon__icon-area">
              <span class="icon-minus-outline" (click)="decreaseAddOn(item)"></span>
              <mat-form-field appearance="standard" class="addon-count">
                <input [(ngModel)]="item.selectedQuantity" type="number" (keypress)="isNumberKey($event)" (ngModelChange)="validateAddOnsQtyOnChange(item)"
                  (focusout)="addonQuantityValidations($event, item)" matInput>
              </mat-form-field>
              <span class="icon-add1" (click)="increaseAddOn(item)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- <div *ngIf="notes.commentsBox?.id && !activityService.isDining" class="pt-2" style="font-size: 13px;color: #585252">
      {{'note' | translate}}: {{'specificPartyJoining' | translate}}</div>
    <div *ngIf="notes.commentsBox?.id" class="pt-3 d-flex flex-row">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{'leaveaComment' | translate}}</mat-label>
        <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="{{'addCommentsHere' | translate}}"></textarea>
      </mat-form-field>
    </div> -->
    </div>
  </mat-card>
  
         
        <mat-card class="guest-details-block float-left"  [ngClass]="[(mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0) && allEligibleAddOns?.length ? 'col-lg-6 col-md-12 col-xl-6 col-xs-12 col-sm-12' 
          : 'm-auto col-lg-8 col-md-8 col-xl-8 col-sm-8 col-xs-8']">
          <div class="addon__header w-100">
            <span>{{'guestDetails' | translate}}</span>
            </div>
          <div class="guest-section" [ngClass]="{'alias-name' : !activityService?.widgetSettings?.ShowAliasName}">
            <dynamic-form [config]="guestConfig" #form="dynamicForm">
            </dynamic-form>
          </div>
          <div class="notes-section">
            <ng-container *ngTemplateOutlet="notesDisplayContent"></ng-container>
          </div>
          <div *ngIf="this.activityService.selectedDining.MarketingFlagEnabled" class="marketingFlag-section">
            <dynamic-form [config]="marketingFlag" #form="dynamicForm">
            </dynamic-form>
          </div>
          <div *ngIf="allowAddingSecondaryGuest && secondaryGuestDetails && secondaryGuestDetails.length > 0"
            class="guest-section__secondary-guest pt-4">
            <div class="guest-section__secondary-guest-details pb-4"
              *ngFor="let secondaryGuest of secondaryGuestDetails;let i = index;" [hidden]="this.editContactData?.Id && secondaryGuest?.ContactId == this.editContactData?.Id ">
              <app-activities-lite-secondary-guest-data [restaurantDetail]="restaurantData"  [secondaryGuestCount]="i+1" [secondaryGuestVisibileFields]="secondaryGuestVisibileFields"
              [selectedActivity]="selectedActivity" [secondaryGuestDetail]="secondaryGuest" (deleteSecondaryGuest)="deleteSecondaryGuest($event)" [customGuestFields]="customGuestFields" (secondaryGuestNotes)="secondaryGuestNotes($event)" (secondaryGuestData)="secondaryGuestValid($event)"></app-activities-lite-secondary-guest-data>
            </div>
          </div>
          <button *ngIf="allowAddingSecondaryGuest && additionalSecondaryGuestCount" mat-button type="button"
            class="my-3 activity-buttons activity-confirm-buttons add-guest-btn-decoration text-center text-uppercase"
            (click)="addSecondaryGuestDetails();">
            {{'addAdditionalGuest' | translate}}
          </button>
        </mat-card>
      </div>
    
      </div>
      <!-- <div class="col-lg-2 col-md-2 col-xl-2"> 

      </div> -->
    </div>

    <div class="col-12 container cancellation-policy"  *ngIf="!this.activityService.isDining && activityService?.selectedSpecialMeal?.CancellationPolicy">
      <mat-card [ngClass]="{'col-lg-12 col-md-12 col-xl-12 col-sm-12 col-xs-12 m-auto': (mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0)}"
                [ngClass]="{'col-lg-8 col-md-12 col-xl-8 col-sm-12 col-xs-12 m-auto': !(mandatoryAddOns?.length > 0 || additionalAddOns?.length > 0)}">
        <h3 class="cancellation-policy__policy-header">
          {{'CancellationPolicy' | translate}}
        </h3>
        <div class="cancellation-policy__content">
          {{activityService?.selectedSpecialMeal?.CancellationPolicy}}
        </div>
      </mat-card>
    </div>
  </div>

  <ng-template #notesDisplayContent>
    <ng-container *ngFor="let notes of notesOptions">
      <!-- Enable when Notes is added for Activities -->
      <div *ngIf="notes.text" class="activity-description-bolder text-uppercase">
        {{notes.text}}
      </div>
      <div class="d-flex flex-row">
        <mat-chip-list selectable multiple>
          <mat-chip class="cursor" #c="matChip" *ngFor="let option of notes.checkBoxOptions" [selected]="option.selected"
            [value]="option.value" (click)="toggleSelection(c, option)">
            <mat-icon class="chip-check-icon" *ngIf="c.selected">check</mat-icon>
            {{option.value}}
          </mat-chip>
        </mat-chip-list>
      </div>
      <!-- <div *ngIf="notes.commentsBox?.id && !activityService.isDining" class="pt-2" style="font-size: 13px;color: #585252">
        Note: Please specify the party that you are joining</div> -->
      <div *ngIf="notes.commentsBox?.id" class="pt-3 d-flex flex-row">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{'leaveaComment' | translate}}</mat-label>
          <textarea [(ngModel)]="notes.commentsBox.value" matInput placeholder="{{'addCommentsHere' | translate}}"></textarea>
        </mat-form-field>
      </div>
    </ng-container>
  </ng-template>
